// extracted by mini-css-extract-plugin
export default {"element":"Settings_element__dKZAc"};